{{ date | momentFormat: 'DD MMM YYYY' | async }}
